const fn = {
  init: () => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (entry.target.classList.contains('panel') || entry.target.classList.contains('section-panel')) {
              fn.updateActiveLink(entry.target)
            } else {
              fn.clearActiveLink()
            }
          }
        })
      },
      {
        threshold: 1,
      }
    )

    document.querySelectorAll('section.panel').forEach((el) => observer.observe(el))

    document.querySelectorAll('section.section-panel').forEach((el) => observer.observe(el))

    observer.observe(document.querySelector('.page-header'))
  },

  updateActiveLink: (el) => {
    const link = document.querySelector(`.panel-link[data-panel-id="${el.id}"]`)

    fn.clearActiveLink()

    if (link) {
      link.classList.add('is-active')
    }
  },

  clearActiveLink: () => {
    document.querySelectorAll('.panel-links .panel-link').forEach((x) => x.classList.remove('is-active'))
  },
}

export default {
  can: () => document.body.classList.contains('has-panel-observer'),
  run: fn.init,
}
